(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name commons.controller:ConfirmOverlapCtrl
   *
   * @description
   *
   */
  angular
    .module('commons')
    .controller('ConfirmOverlapCtrl', ConfirmOverlapCtrl);

  function ConfirmOverlapCtrl($uibModalInstance, modalParams) {
    var vm = this;

    vm.model = {
      title: modalParams.title,
      msgCol: modalParams.messages || [],
    };

    vm.onCloseClick = function () {
      $uibModalInstance.close(modalParams.close);
    };

    vm.onYesClick = function(){
      $uibModalInstance.close('SWAP');
    };

    vm.onNoClick = function(){
      $uibModalInstance.close('OK');
    };
  }
}());
